<template>
  <div class="aerial-view-image-container">
    <img src="static/images/venue/aerialView/1.jpg"/>
    <img src="static/images/venue/aerialView/2.jpg"/>
    <img src="static/images/venue/aerialView/3.jpg"/>
  </div>
</template>
<script>
  import {aerialView} from './constant/NavConstant'
  import {UPDATE_VENUE_PAGE_TYPE} from 'src/store/mutations-types'

  export default {
    data () {
      return {}
    },
    props: {},
    components: {},
    mounted () {
      this.$nextTick(function () {
        this.$store.commit(UPDATE_VENUE_PAGE_TYPE, aerialView)
      })
    },
    methods: {}
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/venue/AerialView.vue